// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2966O","placeholdersHeader":"styles_placeholdersHeader__1JyAp","editorStyle":"styles_editorStyle__2YKye","placeholdersBox":"styles_placeholdersBox__2CRDW"};